import {Fonts} from "@/constants/font";
import BBCodeText from "phaser3-rex-plugins/plugins/bbcodetext";
import {Keys} from "@/constants/key";
import {Tr} from "@/i18n/i18n";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";
import Text from "phaser3-rex-plugins/plugins/gameobjects/text/textbase/Text";
import {Tag} from "@/store/forum/types";
import {ClickableTag} from "@/scenes.ui.forum/clickable-tag";
import ForumStore from "@/store/forum";

export class FilterLine extends Phaser.GameObjects.Container {

    clickableTags:ClickableTag[] = [];
    tagCallback!: (tag:Tag) => unknown;

    constructor(scene: Phaser.Scene, canvas: HTMLCanvasElement, headTags:Tag[], isClanForum:boolean, callback: () => unknown, tagCallback: (tag:Tag|undefined) => unknown) {
        super(scene);

        this.scene = scene;
        this.tagCallback = tagCallback;
        this.height = 50;

        const back = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK).setOrigin(0.5, 0);
        SpriteUtils.setDispSize(back, CU.CANVAS_WIDTH, this.height * CU.S);
        const separator = SpriteUtils.addSprite(this.scene!, 0, this.height, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0.5, 0.5);

        let textStyle : Text.TextStyle= {
            fontFamily: Fonts.MYRIADPRO_REGULAR,
            fontSize: '13pt',
            align: 'center',
            wrap: {
                mode: 1,
                width: 420
            },
            underline: {
                color: '#C4C4C4',
                thickness: 2,
                offset: 2
            }
        }

        let link = new BBCodeText(scene, (isClanForum? 0 : CU.CANVAS_WIDTH/2 - 20), 25 * CU.S, '[color=#C4C4C4][u]' + Tr('srch') + '[/u][/color]', textStyle).setScale(CU.S, CU.S);
        link.setOrigin(isClanForum? 0.5: 1, 0.5);
        link.setInteractive().on('pointerup', () => {
            callback();
        });
        this.add([back, link, separator]);

        if (!isClanForum) {
            let offset = 15
            headTags.forEach((tag, index) => {
                let x = index == 0 ? -CU.CANVAS_WIDTH / 2 + offset * CU.S : this.clickableTags[index - 1].getCloseX() + offset * CU.S;
                let clickableTag = new ClickableTag(scene, canvas, tag, x, 24 * CU.S, tagCallback);
                this.clickableTags.push(clickableTag);
            });
            this.add(this.clickableTags);
        }
    }

}
